!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.ReactItemsCarousel = t() : e.ReactItemsCarousel = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 7);
  }([function (e, t) {
    e.exports = require("prop-types");
  }, function (e, t) {
    e.exports = require("react");
  }, function (e, t) {
    e.exports = require("lodash.min");
  }, function (e, t) {
    e.exports = require("styled-components");
  }, function (e, t) {
    e.exports = require("lodash.max");
  }, function (e, t) {
    e.exports = require("react-motion");
  }, function (e, t) {
    e.exports = require("react-measure");
  }, function (e, t, r) {
    "use strict";

    r.r(t);

    var n = r(1),
        o = r.n(n),
        i = r(2),
        a = r.n(i),
        u = r(4),
        c = r.n(u),
        s = function s(e) {
      return 2 * e.gutter;
    },
        l = function l(e) {
      return e.gutter;
    },
        f = function f(e) {
      var t = e.containerWidth,
          r = e.gutter,
          n = e.numberOfCards,
          o = e.firstAndLastGutter,
          i = r * (n - 1);
      return e.showSlither && (i += 2 * l({
        gutter: r
      })), o && (i += s({
        gutter: r
      })), (t - i) / n;
    },
        h = function h(e) {
      var t = e.index,
          r = e.firstAndLastGutter,
          n = e.gutter;
      return 0 === t ? r ? s({
        gutter: n
      }) : 0 : n / 2;
    },
        p = function p(e) {
      var t = e.index,
          r = e.firstAndLastGutter,
          n = e.gutter;
      return t === e.numberOfChildren - 1 ? r ? s({
        gutter: n
      }) : 0 : n / 2;
    },
        d = function d(e) {
      var t,
          r = e.activeItemIndex,
          n = e.activePosition,
          o = e.containerWidth,
          i = e.numberOfChildren,
          a = e.numberOfCards,
          u = e.gutter,
          c = e.firstAndLastGutter,
          h = e.showSlither,
          p = e.infiniteLoop,
          d = r;
      if ("center" === n && (d -= Math.floor(a / 2)), "right" === n && (d -= a - 1), (t = {
        numberOfChildren: i,
        numberOfCards: a
      }).numberOfChildren < t.numberOfCards) return 0;
      if (!p && d <= 0) return 0;
      if (!p && d > i - a - 1) return function (e) {
        e.activeItemIndex, e.activePosition;
        var t = e.containerWidth,
            r = e.numberOfChildren,
            n = e.numberOfCards,
            o = e.gutter,
            i = e.firstAndLastGutter,
            a = e.showSlither,
            u = r - n,
            c = f({
          containerWidth: t,
          gutter: o,
          numberOfCards: n,
          firstAndLastGutter: i,
          showSlither: a
        }) * u + o * u;
        return i && !a && (c += s({
          gutter: o
        })), c;
      }({
        activeItemIndex: d,
        activePosition: n,
        containerWidth: o,
        numberOfChildren: i,
        numberOfCards: a,
        gutter: u,
        firstAndLastGutter: c,
        showSlither: h
      });
      var m = f({
        containerWidth: o,
        gutter: u,
        numberOfCards: a,
        firstAndLastGutter: c,
        showSlither: h
      }) * d + u * d;
      return h && (m -= l({
        gutter: u
      })), c && (m += u), m;
    },
        m = function m(e) {
      var t = e.activeItemIndex,
          r = e.activePosition,
          n = e.numberOfCards,
          o = e.numberOfChildren,
          i = e.slidesToScroll;
      return !(o <= n) && v({
        activeItemIndex: t,
        activePosition: r,
        numberOfCards: n,
        numberOfChildren: o,
        slidesToScroll: i
      }) > t;
    },
        b = function b(e) {
      var t = e.activeItemIndex,
          r = e.activePosition,
          n = e.numberOfCards,
          o = e.numberOfChildren,
          i = e.slidesToScroll;
      return !(o <= n) && y({
        activeItemIndex: t,
        activePosition: r,
        numberOfCards: n,
        numberOfChildren: o,
        slidesToScroll: i
      }) < t;
    },
        v = function v(e) {
      var t = e.activePosition,
          r = e.activeItemIndex,
          n = e.numberOfChildren,
          o = e.numberOfCards,
          i = e.slidesToScroll;

      switch (t) {
        case "right":
          return c()([a()([r + i, n - 1]), o]);

        case "center":
          return c()([a()([r + i, Math.floor(n - o / 2)]), Math.floor(o / 2) + 1]);

        case "left":
          return a()([r + i, n - o]);
      }
    },
        y = function y(e) {
      var t = e.activePosition,
          r = e.activeItemIndex,
          n = e.numberOfCards,
          o = e.numberOfChildren,
          i = e.slidesToScroll;

      switch (t) {
        case "right":
          return c()([a()([r - i, o - 1]), n - 1]);

        case "center":
          return c()([a()([r - i, Math.floor(o - n / 2) - 1]), Math.floor(n / 2)]);

        case "left":
          return a()([c()([r - i, 0]), o - n - 1]);
      }
    };

    function O(e) {
      return (O = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function g() {
      return (g = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function C(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function S(e) {
      return (S = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function w(e, t) {
      return (w = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function I(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function T(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var P = function P(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return e && e.length > 0 ? e[0].clientX : t;
    },
        x = r(6),
        j = r.n(x);

    function W(e) {
      return (W = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function A() {
      return (A = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function _(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function E(e, t) {
      return !t || "object" !== W(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function L(e) {
      return (L = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function G(e, t) {
      return (G = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var X = r(5),
        M = r(3),
        R = r.n(M),
        q = r(0),
        k = r.n(q),
        N = {
      children: k.a.arrayOf(k.a.element).isRequired,
      numberOfCards: k.a.number,
      gutter: k.a.number,
      showSlither: k.a.bool,
      firstAndLastGutter: k.a.bool,
      enablePlaceholder: k.a.bool,
      placeholderItem: k.a.element,
      numberOfPlaceholderItems: k.a.number,
      requestToChangeActive: k.a.func.isRequired,
      activeItemIndex: k.a.number.isRequired,
      activePosition: k.a.oneOf(["left", "center", "right"]),
      rightChevron: k.a.oneOfType([k.a.element, k.a.string]),
      leftChevron: k.a.oneOfType([k.a.element, k.a.string]),
      chevronWidth: k.a.number,
      outsideChevron: k.a.bool,
      alwaysShowChevrons: k.a.bool,
      slidesToScroll: k.a.number,
      disableSwipe: k.a.bool,
      springConfig: k.a.shape({
        stiffness: k.a.number,
        damping: k.a.number,
        precision: k.a.number
      }),
      onActiveStateChange: k.a.func,
      classes: k.a.shape({
        wrapper: k.a.string,
        itemsWrapper: k.a.string,
        itemsInnerWrapper: k.a.string,
        itemWrapper: k.a.string,
        rightChevronWrapper: k.a.string,
        leftChevronWrapper: k.a.string
      }),
      infiniteLoop: k.a.bool,
      calculateActualTranslateX: k.a.func
    };

    function D(e) {
      return (D = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function U(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {},
            n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function (t) {
          J(e, t, r[t]);
        });
      }

      return e;
    }

    function z(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function F(e) {
      return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function H(e, t) {
      return (H = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function B(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function J(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function K() {
      var e = te(["\n  left: -", "px;\n"]);
      return K = function K() {
        return e;
      }, e;
    }

    function Q() {
      var e = te(["\n  right: -", "px;\n"]);
      return Q = function Q() {
        return e;
      }, e;
    }

    function V() {
      var e = te(["\n  position: absolute;\n  height: 100%;\n  width: ", "px;\n  cursor: pointer;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);
      return V = function V() {
        return e;
      }, e;
    }

    function Y() {
      var e = te(["\n  width: ", "px;\n  flex-shrink: 0;\n  margin-right: ", "px;\n  margin-left: ", "px;\n"]);
      return Y = function Y() {
        return e;
      }, e;
    }

    function Z() {
      var e = te(["\n  width: 100%;\n  display: flex;\n  flex-wrap: nowrap;\n"]);
      return Z = function Z() {
        return e;
      }, e;
    }

    function $() {
      var e = te(["\n  width: 100%;\n  overflow-x: hidden;\n"]);
      return $ = function $() {
        return e;
      }, e;
    }

    function ee() {
      var e = te(["\n  position: relative;\n  ", "\n"]);
      return ee = function ee() {
        return e;
      }, e;
    }

    function te(e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }

    var re = R.a.div(ee(), function (e) {
      return e.height && "height: ".concat(e.height, "px;");
    }),
        ne = R.a.div($()),
        oe = R.a.div(Z()),
        ie = R.a.div(Y(), function (e) {
      return e.width;
    }, function (e) {
      return e.rightGutter;
    }, function (e) {
      return e.leftGutter;
    }),
        ae = R.a.div(V(), function (e) {
      return e.chevronWidth + 1;
    }),
        ue = R()(function (e) {
      return o.a.createElement(ae, e);
    })(Q(), function (e) {
      return e.outsideChevron ? e.chevronWidth : 0;
    }),
        ce = R()(function (e) {
      return o.a.createElement(ae, e);
    })(K(), function (e) {
      return e.outsideChevron ? e.chevronWidth : 0;
    }),
        se = function (e) {
      function t() {
        var e, r, n, o;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var i = arguments.length, a = new Array(i), u = 0; u < i; u++) {
          a[u] = arguments[u];
        }

        return n = this, o = (e = F(t)).call.apply(e, [this].concat(a)), r = !o || "object" !== D(o) && "function" != typeof o ? B(n) : o, J(B(B(r)), "getScrollState", function () {
          var e = r.props,
              t = e.numberOfCards,
              n = e.activeItemIndex,
              o = e.activePosition,
              i = e.slidesToScroll,
              a = e.items;
          return {
            isLastScroll: !m({
              activeItemIndex: n,
              activePosition: o,
              numberOfChildren: a.length,
              numberOfCards: t,
              slidesToScroll: i
            }),
            isFirstScroll: !b({
              activeItemIndex: n,
              activePosition: o,
              numberOfChildren: a.length,
              numberOfCards: t,
              slidesToScroll: i
            })
          };
        }), r;
      }

      var r, n, i;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && H(e, t);
      }(t, o.a.Component), r = t, (n = [{
        key: "componentDidUpdate",
        value: function value(e) {
          this.props.onActiveStateChange && this.props.activeItemIndex !== e.activeItemIndex && this.props.onActiveStateChange(U({}, this.getScrollState()));
        }
      }, {
        key: "renderList",
        value: function value(e) {
          var t = e.items,
              r = e.translateX,
              n = e.containerWidth,
              i = e.measureRef,
              a = this.props,
              u = a.gutter,
              c = a.numberOfCards,
              s = a.firstAndLastGutter,
              l = a.showSlither,
              d = a.classes,
              m = (0, a.calculateActualTranslateX)(r);
          return o.a.createElement(ne, {
            className: d.itemsWrapper
          }, o.a.createElement(oe, {
            ref: i,
            style: {
              transform: "translateX(".concat(-1 * m, "px)")
            },
            className: d.itemsInnerWrapper
          }, t.map(function (e, r) {
            return o.a.createElement(ie, {
              key: r,
              className: d.itemWrapper,
              width: f({
                firstAndLastGutter: s,
                containerWidth: n,
                gutter: u,
                numberOfCards: c,
                showSlither: l
              }),
              leftGutter: h({
                index: r,
                firstAndLastGutter: s,
                gutter: u
              }),
              rightGutter: p({
                index: r,
                firstAndLastGutter: s,
                gutter: u,
                numberOfChildren: t.length
              })
            }, e);
          })));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              r = t.containerWidth,
              n = t.measureRef,
              i = t.touchRelativeX,
              a = t.onWrapperTouchStart,
              u = t.onWrapperTouchEnd,
              c = t.onWrapperTouchMove,
              s = (t.gutter, t.numberOfCards, t.firstAndLastGutter, t.activePosition, t.springConfig),
              l = (t.showSlither, t.rightChevron),
              f = t.leftChevron,
              h = t.chevronWidth,
              p = t.outsideChevron,
              d = t.requestToChangeActive,
              m = (t.slidesToScroll, t.alwaysShowChevrons),
              b = t.classes,
              v = t.items,
              y = t.activeItemTranslateX,
              O = t.nextItemIndex,
              g = t.previousItemIndex,
              C = this.getScrollState(),
              S = C.isFirstScroll,
              w = C.isLastScroll,
              I = l && (m || !w),
              T = f && (m || !S);
          return o.a.createElement(re, {
            onTouchStart: a,
            onTouchEnd: u,
            onTouchMove: c,
            className: b.wrapper
          }, o.a.createElement(X.Motion, {
            defaultStyle: {
              translateX: y
            },
            style: {
              translateX: Object(X.spring)(y + i, s)
            },
            children: function children(t) {
              var o = t.translateX;
              return e.renderList({
                items: v,
                measureRef: n,
                containerWidth: r,
                translateX: o
              });
            }
          }), I && o.a.createElement(ue, {
            chevronWidth: h,
            outsideChevron: p,
            className: b.rightChevronWrapper,
            onClick: function onClick() {
              return d(O);
            }
          }, l), T && o.a.createElement(ce, {
            chevronWidth: h,
            outsideChevron: p,
            className: b.leftChevronWrapper,
            onClick: function onClick() {
              return d(g);
            }
          }, f));
        }
      }]) && z(r.prototype, n), i && z(r, i), t;
    }();

    se.defaultProps = {
      onWrapperTouchStart: null,
      onWrapperTouchEnd: null,
      onWrapperTouchMove: null
    }, se.propTypes = U({}, N, {
      items: k.a.arrayOf(k.a.node).isRequired,
      activeItemTranslateX: k.a.number.isRequired,
      nextItemIndex: k.a.number.isRequired,
      previousItemIndex: k.a.number.isRequired,
      containerWidth: k.a.number.isRequired,
      measureRef: k.a.oneOfType([k.a.func, k.a.shape({
        current: k.a.object
      })]).isRequired,
      touchRelativeX: k.a.number.isRequired,
      onWrapperTouchStart: k.a.func,
      onWrapperTouchEnd: k.a.func,
      onWrapperTouchMove: k.a.func
    });
    var le = se;

    function fe(e) {
      return (fe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function he() {
      return (he = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function pe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function de(e) {
      return (de = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function me(e, t) {
      return (me = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function be(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function ve(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function ye() {
      return (ye = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var Oe = function Oe() {
      return function (e) {
        return function (t) {
          var r = t.children,
              n = t.activeItemIndex,
              i = t.activePosition,
              a = t.containerWidth,
              u = t.numberOfCards,
              c = t.slidesToScroll,
              s = t.gutter,
              l = t.firstAndLastGutter,
              f = t.showSlither,
              h = o.a.Children.toArray(r);
          return o.a.createElement(e, ye({}, t, {
            items: h,
            nextItemIndex: v({
              activePosition: i,
              activeItemIndex: n,
              numberOfCards: u,
              slidesToScroll: c,
              numberOfChildren: h.length
            }),
            previousItemIndex: y({
              activePosition: i,
              activeItemIndex: n,
              numberOfCards: u,
              slidesToScroll: c,
              numberOfChildren: h.length
            }),
            activeItemTranslateX: d({
              activeItemIndex: n,
              activePosition: i,
              containerWidth: a,
              numberOfChildren: h.length,
              numberOfCards: u,
              gutter: s,
              firstAndLastGutter: l,
              showSlither: f
            })
          }));
        };
      };
    };

    function ge(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }

          return r;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    var Ce = function Ce(e) {
      var t = e.activeItemIndex,
          r = e.activePosition,
          n = e.containerWidth,
          o = e.numberOfChildren,
          i = e.numberOfCards,
          a = e.gutter,
          u = e.firstAndLastGutter,
          c = e.showSlither;
      return d({
        activeItemIndex: t,
        activePosition: r,
        containerWidth: n,
        numberOfChildren: o,
        numberOfCards: i,
        gutter: a,
        firstAndLastGutter: u,
        showSlither: c,
        infiniteLoop: !0
      });
    },
        Se = function Se(e, t) {
      var r = t.numberOfCards;
      return [].concat(ge(e.slice(e.length - r)), ge(e), ge(e.slice(0, r)));
    },
        we = function we(e) {
      return e.activeItemIndex - e.slidesToScroll;
    },
        Ie = function Ie(e) {
      return e.activeItemIndex + e.slidesToScroll;
    },
        Te = function Te(e) {
      var t = e.activeItemIndex;
      e.numberOfCards;
      return t;
    },
        Pe = Ce,
        xe = function xe(e, t, r) {
      var n = r.activePosition,
          o = r.containerWidth,
          i = r.numberOfCards,
          a = r.gutter,
          u = r.firstAndLastGutter,
          c = r.showSlither,
          s = Ce({
        numberOfChildren: e.length,
        activeItemIndex: e.length - 2 * i,
        activePosition: n,
        containerWidth: o,
        numberOfCards: i,
        gutter: a,
        firstAndLastGutter: u,
        showSlither: c
      }),
          l = t % s + Ce({
        numberOfChildren: e.length,
        activeItemIndex: i,
        activePosition: n,
        containerWidth: o,
        numberOfCards: i,
        gutter: a,
        firstAndLastGutter: u,
        showSlither: c
      });
      return l <= 0 ? s - Math.abs(l) : l;
    };

    function je() {
      return (je = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var We = function We() {
      return function (e) {
        return function (t) {
          var r = t.calculateActualTranslateX,
              n = t.numberOfCards,
              i = t.activeItemIndex,
              a = (t.numberOfChildren, t.slidesToScroll),
              u = t.containerWidth,
              c = t.gutter,
              s = t.firstAndLastGutter,
              l = t.showSlither,
              f = t.children,
              h = Se(o.a.Children.toArray(f), {
            numberOfCards: n
          }),
              p = Te({
            activeItemIndex: i,
            numberOfCards: n
          }),
              d = we({
            activeItemIndex: p,
            slidesToScroll: a
          }),
              m = Ie({
            activeItemIndex: p,
            slidesToScroll: a
          }),
              b = Pe({
            activeItemIndex: p,
            activePosition: "left",
            containerWidth: u,
            numberOfChildren: h.length,
            numberOfCards: n,
            gutter: c,
            firstAndLastGutter: s,
            showSlither: l
          });
          return o.a.createElement(e, je({}, t, {
            alwaysShowChevrons: !0,
            activePosition: "left",
            items: h,
            previousItemIndex: d,
            nextItemIndex: m,
            activeItemIndex: p,
            activeItemTranslateX: b,
            calculateActualTranslateX: function calculateActualTranslateX(e) {
              var t = xe(h, e, {
                activePosition: "left",
                containerWidth: u,
                numberOfCards: n,
                gutter: c,
                firstAndLastGutter: s,
                showSlither: l
              });
              return r(t);
            }
          }));
        };
      };
    },
        Ae = function () {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }

      return function (e) {
        return t.reduce(function (e, t) {
          return t(e);
        }, e);
      };
    }(function (e) {
      return function (t) {
        function r() {
          var e, t, n, o;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r);

          for (var i = arguments.length, a = new Array(i), u = 0; u < i; u++) {
            a[u] = arguments[u];
          }

          return n = this, o = (e = S(r)).call.apply(e, [this].concat(a)), t = !o || "object" !== O(o) && "function" != typeof o ? I(n) : o, T(I(I(t)), "state", {
            startTouchX: 0,
            currentTouchX: 0
          }), T(I(I(t)), "onWrapperTouchStart", function (e) {
            var r = P(e.touches);
            t.setState({
              startTouchX: r,
              currentTouchX: r
            });
          }), T(I(I(t)), "onWrapperTouchEnd", function (e) {
            var r = t.props,
                n = r.containerWidth,
                o = r.gutter,
                i = r.numberOfCards,
                a = r.firstAndLastGutter,
                u = r.showSlither,
                c = r.requestToChangeActive,
                s = r.activeItemIndex,
                l = f({
              containerWidth: n,
              gutter: o,
              numberOfCards: i,
              firstAndLastGutter: a,
              showSlither: u
            }),
                h = P(e.changedTouches),
                p = t.state.startTouchX - h,
                d = Math.floor(Math.abs(p) / (l + o / 2) + .75);
            d > 0 && c(p < 0 ? s - d : s + d), t.setState({
              startTouchX: 0,
              currentTouchX: 0
            });
          }), T(I(I(t)), "onWrapperTouchMove", function (e) {
            t.setState({
              currentTouchX: P(e.touches)
            });
          }), t;
        }

        var n, i, a;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && w(e, t);
        }(r, o.a.Component), n = r, (i = [{
          key: "render",
          value: function value() {
            var t = this.props,
                r = t.disableSwipe,
                n = t.isPlaceholderMode,
                i = this.state,
                a = i.startTouchX,
                u = i.currentTouchX;
            return r || n ? o.a.createElement(e, g({}, this.props, {
              touchRelativeX: 0
            })) : o.a.createElement(e, g({}, this.props, {
              onWrapperTouchStart: this.onWrapperTouchStart,
              onWrapperTouchEnd: this.onWrapperTouchEnd,
              onWrapperTouchMove: this.onWrapperTouchMove,
              touchRelativeX: a - u
            }));
          }
        }]) && C(n.prototype, i), a && C(n, a), r;
      }();
    }, function (e) {
      return function (t) {
        function r(e) {
          var t, n, i;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), n = this, i = de(r).call(this, e), t = !i || "object" !== fe(i) && "function" != typeof i ? be(n) : i, ve(be(be(t)), "startPlaceholderMinimumTimer", function () {
            t.props.minimumPlaceholderTime && (t.placeholderTimer = setTimeout(function () {
              t.placeholderTimer = null, o.a.Children.count(t.props.children) > 0 && t.setState({
                isPlaceholderMode: !1
              });
            }, t.props.minimumPlaceholderTime));
          }), ve(be(be(t)), "getPlaceholderItems", function () {
            var e = t.props,
                r = e.placeholderItem,
                n = e.numberOfPlaceholderItems;
            return Array.from(Array(n)).map(function (e) {
              return r;
            });
          }), t.state = {
            isPlaceholderMode: t.props.enablePlaceholder && 0 === o.a.Children.count(t.props.children)
          }, t;
        }

        var n, i, a;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && me(e, t);
        }(r, o.a.Component), n = r, (i = [{
          key: "componentDidMount",
          value: function value() {
            this.startPlaceholderMinimumTimer();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.placeholderTimer && clearTimeout(this.placeholderTimer);
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            o.a.Children.count(this.props.children) > 0 && 0 === o.a.Children.count(e.children) && !this.placeholderTimer && this.state.isPlaceholderMode && this.setState({
              isPlaceholderMode: !1
            });
          }
        }, {
          key: "render",
          value: function value() {
            return o.a.createElement(e, he({}, this.props, {
              items: this.state.isPlaceholderMode ? this.getPlaceholderItems() : this.props.items
            }));
          }
        }]) && pe(n.prototype, i), a && pe(n, a), r;
      }();
    }, function (e) {
      return function (t) {
        var r = o.a.Children.toArray(t.children).length >= t.numberOfCards;
        return t.infiniteLoop && r ? We()(e)(t) : Oe()(e)(t);
      };
    }, function (e) {
      return function (t) {
        function r() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), E(this, L(r).apply(this, arguments));
        }

        var n, i, a;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && G(e, t);
        }(r, o.a.Component), n = r, (i = [{
          key: "render",
          value: function value() {
            var t = this;
            return o.a.createElement(j.a, {
              bounds: !0,
              margin: !1,
              whitelist: ["width", "height"]
            }, function (r) {
              var n = r.measureRef,
                  i = r.contentRect;
              return o.a.createElement(e, A({}, t.props, {
                measureRef: n,
                containerWidth: i.bounds.width || 0,
                containerHeight: i.bounds.height || 0
              }));
            });
          }
        }]) && _(n.prototype, i), a && _(n, a), r;
      }();
    })(le);

    Ae.propTypes = N, Ae.defaultProps = {
      numberOfCards: 3,
      gutter: 0,
      disableSwipe: !1,
      firstAndLastGutter: !1,
      showSlither: !1,
      enablePlaceholder: !1,
      activePosition: "left",
      slidesToScroll: 1,
      placeholderItem: null,
      numberOfPlaceholderItems: 0,
      rightChevron: null,
      leftChevron: null,
      onActiveStateChange: null,
      alwaysShowChevrons: !1,
      classes: {},
      infiniteLoop: !1,
      calculateActualTranslateX: function calculateActualTranslateX(e) {
        return e;
      }
    };
    t.default = Ae;
  }]);
});